module.exports = __webpack_public_path__ + "static/media/motel-lasvegas-logo.6e916806.png";